import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import classNames from 'classnames';
import { register } from '../i18n';

// remove manuscript when all components are built and manuscript items are removed from
// preview, graded and review modes
import '../css/Player.scss';
import '../css/Manuscript.scss';
import '../css/TestItems.scss';
import '../css/CkeditorContentStyles.scss';
import '../css/Accessibility.scss';

import { LessonMode } from '../Constants';

import useLessonInit from '../hooks/useLessonInit';
import InternetMessage from '../lessonPlayer/components/InternetMessage';

import BackgroundShade from '../lessonPlayer/layout/BackgroundShade';
import ContentLayout from '../lessonPlayer/layout/ContentLayout';
import FooterLayout from '../lessonPlayer/layout/FooterLayout';
import FullpageLoader from '../lessonPlayer/components/FullpageLoader';
import HiddenAudioPlayer from '../lessonPlayer/components/HiddenAudioPlayer';
import ScoringToolbarLayout from '../lessonPlayer/layout/ScoringToolbarLayout';
import AccessibilityAnnouncer from '../lessonPlayer/components/AccessibilityAnnouncer';

const t = register('AriaLabels');

const ScoreMode = observer(() => {
  const {
    lessonManager,
    toolbarManager,
  } = useContext(MobXProviderContext);

  useLessonInit(LessonMode.SCORING);

  useEffect(() => {
    const className = `${LessonMode.SCORING} theme-override`;
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('class', className);
  });

  return (
    <>
      <div id="ariaLiveMessage" aria-live="polite">{lessonManager.currentAriaMessage}</div>
      <AccessibilityAnnouncer />
      {/* eslint-disable-next-line no-nested-ternary */}
      {(lessonManager.isOnline && lessonManager.isLoaded && ((lessonManager.themeLoaded && lessonManager.translationsLoaded) || lessonManager.hasNoTheme)) ? (
        <div className={classNames('lesson-window', { highlightOn: toolbarManager.isHighlightOrStickyToolOn })}>
          <BackgroundShade>
            <HiddenAudioPlayer/>
            <header aria-label={t('mainMenu')} role='navigation'>
              <ScoringToolbarLayout/>
            </header>
            <main role='main'>
              <ContentLayout isScoring={true}/>
            </main>
            <nav aria-label={t('footer')}>
              <FooterLayout/>
            </nav>
          </BackgroundShade>
        </div>
      ) : (!lessonManager.isOnline) ?
        (
          <InternetMessage/>
        )
        : (
          <FullpageLoader/>
        )}
    </>
  );
});
export default ScoreMode;
